import React, { useEffect, useState } from "react";
import { useStyles } from "../../style";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import HistogramIcon from "assets/histogramIcon";
import ScatterPlot from "shared-component/scatter-plot";
import ScatterPlotFilterComponent from "./scatterPlotFilterComponent";
import { getVinListMapData } from "utility/helper";

interface ScatterPlotVisualizationPropTypes {
  vinListTimeSeries: string[];
  updateScatterPLotFilter: (value: any) => void;
  aggregateType?: any;
  signalList: any;
  groupBy: any;
  headerJobId: string;
  jobDetails: any;
  setSelectedVinListVisualization: (value: any) => void;
  selectedVINs: string[];
}

const ScatterPlotVisualization = (props: ScatterPlotVisualizationPropTypes) => {
  const style = useStyles();
  const theme = useTheme();
  const [scatterPlotData, setScatterPlotData] = useState<any>(null);
  const [vinListData, setVinListData] = useState<string[]>(props?.vinListTimeSeries);
  const [selectedVinGroup, setSelectedVinGroup] = useState<any>(null);
  const [/*selectedSignalGroup*/, setSelectedSignalGroup] = useState<any>(null);

  const setTargetVin = (value: any) => {
    props.updateScatterPLotFilter(value);
  };

  const handleSelectedVinGroup = (state: any) => {
    setSelectedVinGroup(state);
  }
  const dataa: any = {}
  const { cDadDataVisualizationData, linkCdadFilterAttributes } = dataa

const restructureScatterPlotData = (dataArray: any) => {
  if (typeof dataArray === 'string') {
    dataArray = dataArray.replace(/NaN/g, '0');
    try {
      dataArray = [JSON.parse(dataArray)];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return []; 
    }
  }
  
  return dataArray[0].map((data: any) => {
    const { group_values, vin, signals, ...dynamicValues } = data;
    return {
      group_values:
        typeof group_values === "object"
          ? group_values
          : { value: group_values },
      vin: Array.isArray(vin) ? vin : [vin],
      combinedData: dynamicValues,
    };
  });
};

  useEffect(() => {
    setVinListData(getVinListMapData(linkCdadFilterAttributes))
  }, [linkCdadFilterAttributes])

  useEffect(() => {
    if (cDadDataVisualizationData) {
      const restructuredData = restructureScatterPlotData(cDadDataVisualizationData.data);
      setScatterPlotData(restructuredData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cDadDataVisualizationData]);
  return (
    <Box bgcolor="white">
      {(cDadDataVisualizationData?.isLoading || linkCdadFilterAttributes?.isLoading) && (
        <div className={style.overlay}>
          <div className={style.loader}></div>
        </div>
      )}
      <>
        <div>
          <ScatterPlotFilterComponent
            vinListTimeSeries={vinListData}
            signalList={props.signalList}
            groupBy={props.groupBy}
            aggregateType={props.aggregateType}
            setSelectedVinList={setTargetVin}
            setSelectedVinListVisualization={props.setSelectedVinListVisualization}
            selectedVINs={props.selectedVINs}
            // setSelectedVinGroup={setSelectedVinGroup} 
            handleSelectedVinGroup={handleSelectedVinGroup}
            setSelectedSignalGroup={setSelectedSignalGroup}
            selectedVinGroup={selectedVinGroup}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {cDadDataVisualizationData && props?.signalList ? (
            <Paper
              elevation={2}
              sx={{
                margin: "1%",
                padding: "2%",
                width: "100%",
              }}
            >
              {!scatterPlotData && (
                <Box
                  flex={1}
                  my={2}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                >
                  <HistogramIcon />
                  <Typography
                    variant="caption"
                    textAlign={"center"}
                    color={theme.palette.text.disabled}
                    fontWeight={"bold"}
                    width={350}
                  >
                    Use the VINs from dropdowns to analyse in Scatter Plot data
                    chart!
                  </Typography>
                </Box>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {/* {scatterPlotData &&
                  scatterPlotData.map(
                    (
                      data: {
                        group_values: { [key: string]: string };
                        vin: string[];
                        combinedData: { [key: string]: number[] };
                      },
                      index: React.Key | null | undefined
                    ) => (
                      <div
                        key={index}
                        style={{
                          width: "48%",
                          marginBottom: "20px",
                        }}
                      >
                        <ScatterPlot data={data} selectedVinGroup={selectedVinGroup ? selectedVinGroup[index as number] : undefined} />
                      </div>
                    )
                  )} */}
                {scatterPlotData &&
                  scatterPlotData.map(
                    (
                      data: {
                        group_values: { [key: string]: string };
                        vin: string[];
                        combinedData: { [key: string]: number[] };
                      },
                      index: React.Key | null | undefined
                    ) => {
                      const hasData = Object.values(data.combinedData).some(arr => Array.isArray(arr) && arr.length > 0);
                      return (
                        <div
                          key={index}
                          style={{
                            width: "48%",
                            marginBottom: "20px",
                          }}
                        >
                          {hasData ? (
                            <ScatterPlot data={data} selectedVinGroup={selectedVinGroup ? selectedVinGroup[index as number] : undefined} />
                          ) : (
                            <Typography variant="caption" color={theme.palette.text.disabled} textAlign="center" fontSize="24px">
                              No data found
                            </Typography>
                          )}
                        </div>
                      );
                    }
                  )}
              </div>
            </Paper>
          ) : null}
          {!scatterPlotData && (
            <Paper
              elevation={2}
              sx={{
                margin: "1%",
                padding: "2%",
                width: "100%",
              }}
            >
              <Box
                flex={1}
                my={2}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
              >
                <HistogramIcon />
                <Typography
                  variant="caption"
                  textAlign={"center"}
                  color={theme.palette.text.disabled}
                  fontWeight={"bold"}
                  width={350}
                >
                  Use the Signal/Channel from dropdowns to analyse in Scatter
                  Plot data chart!
                </Typography>
              </Box>
            </Paper>
          )}
        </div>
      </>
    </Box>
  );
};

export default ScatterPlotVisualization;
